// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vault-painting_wrapper__U7EGs","painting":"vault-painting_painting__XuuTG","animatedgradient":"vault-painting_animatedgradient__RkfC7"};